/** The uploadable reports: order exports (toe / toll / estore) and 3PL stock reports (toll-inventory: Toll's SOH workbook; estore-inventory: eStore's hourly SFTP reports). */
export type ReportUploadKind = "toe" | "toll" | "estore" | "toll-inventory" | "estore-inventory";

export const REPORT_UPLOAD_KINDS: ReportUploadKind[] = ["toe", "toll", "estore", "toll-inventory", "estore-inventory"];

/** Stock reports: a snapshot is each warehouse's newest file on or before the day, and building one also imports it into our inventory. */
export const isStockReportKind = (report: ReportUploadKind): boolean => {
  return report === "toll-inventory" || report === "estore-inventory";
};

/** Where to PUT one report file (a presigned S3 URL). */
export interface ReportUploadTarget {
  /** PUT the file here, with Content-Type: contentType, before expiresAt. */
  uploadUrl: string;
  contentType: string;
  /** Where it lands in S3, e.g. theorderexchange/raw/261006_093012_DashboardGridView__AU_.xls */
  key: string;
  expiresAt: string;
}

/** A raw export already in S3 for a report and day (GET /reports/{report}/uploads). */
export interface ReportUploadedFile {
  id: string;
  key: string;
  filename: string;
  size: number;
  /** ISO */
  uploadedAt: string;
}

/** A report's built snapshot for one day. */
export interface ReportSnapshotSummary {
  key: string;
  date: string;
  size: number;
  /** ISO */
  builtAt: string;
}

/** eStore's new SFTP reports copied into S3 by one "Pull now". */
export interface EstoreInventoryPull {
  pulled: number;
  /** Still to copy; the next pull takes them. */
  remaining: number;
  failed: number;
  firstError: string | null;
}
